import { Accordion, Box, Card, Center, Flex, ScrollArea, Stack, Text, Title } from "@mantine/core";
import { COLORS } from "../../../../constants/colorConstants";
import { useCalendarContext } from "../../../../contexts/CalendarContext";
import ErrorCard from "../../../../shared/components/blocks/ErrorCard";
import MutationStatusIcon from "../../../../shared/components/ui/MutationStatusIcon";

export default function CreateFormSubmitCard() {
  return (
    <Center>
      <Card shadow="xs" p="md" radius="lg" mb="md" w={1000} h={540} withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
        <ScrollArea type="hidden" style={{ height: 510 }}>
          <Accordion variant="separated" radius="md" chevronIconSize={24} transitionDuration={200}>
            <CalendarItem />
            <CalendarDatesItem />
          </Accordion>
        </ScrollArea>
      </Card>
    </Center>
  );
}

function CalendarItem() {
  const { createCalendar } = useCalendarContext();

  const renderContent = () => {
    if (createCalendar.isPending) {
      return <Text c={COLORS.DARK_BROWN}>Creating calendar...</Text>;
    }

    if (createCalendar.error) {
      return <ErrorCard error={createCalendar.error} />;
    }

    if (createCalendar.isSuccess) {
      return <Text c={COLORS.DARK_BROWN}>Calendar creation complete. Individual dates can now be generated.</Text>;
    }
  };

  return (
    <Accordion.Item value="calendar">
      <Accordion.Control icon={<MutationStatusIcon mutation={createCalendar} />}>
        <Title order={2} c={COLORS.DARK_BROWN}>
          Calendar Creation
        </Title>
      </Accordion.Control>
      <Accordion.Panel>
        <Box mt={20}>{renderContent()}</Box>
      </Accordion.Panel>
    </Accordion.Item>
  );
}

function CalendarDatesItem() {
  const { upsertCalendarDates } = useCalendarContext();

  const renderContent = () => {
    if (upsertCalendarDates.isPending) {
      return <Text c={COLORS.DARK_BROWN}>Creating dates for calendar...</Text>;
    }

    if (upsertCalendarDates.error) {
      const data = upsertCalendarDates.error.data;
      const failedCount = (data?.totalCount ?? 0) - (data?.successCount ?? 0);

      return (
        <Stack gap="xs">
          <Flex justify="center" gap="md">
            <Text fw={700}>{`Total Attempted: ${data?.totalCount ?? 0}`}</Text>
            <Text fw={700}>{`Total Completed: ${data?.successCount ?? 0}`}</Text>
            <Text fw={700}>{`Total Failed: ${failedCount}`}</Text>
          </Flex>
          <ErrorCard error={upsertCalendarDates.error} />
          {data?.failedBatches?.length && data.failedBatches.map((batch) => <ErrorCard error={batch.error} />)}
        </Stack>
      );
    }

    if (upsertCalendarDates.isSuccess) {
      return (
        <Text
          c={COLORS.DARK_BROWN}
        >{`${upsertCalendarDates.data?.successCount ?? 0} Individual dates have been created for this calendar.`}</Text>
      );
    }
  };

  return (
    <Accordion.Item value="calendar-dates">
      <Accordion.Control icon={<MutationStatusIcon mutation={upsertCalendarDates} />}>
        <Title order={2} c={COLORS.DARK_BROWN}>
          Calendar Dates
        </Title>
      </Accordion.Control>
      <Accordion.Panel>
        <Box mt={20}>{renderContent()}</Box>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
